export class IAnimalImage {
  id?: number;
  animalId?: number;
  fileName?: string;
  isPrincipal?: boolean;
  creationDate?: Date;
  fileBase64?: string;
}
